import Text from "@/components/common/Text";
import React from "react";

export default function DefaultHeader({ color, header }) {
	return (
		<Text color={color} className="typo-borna typo-borna-10 header">
			{header}
		</Text>
	)
}